(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buying-guide-banner"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const responsiveBanner = function() {
      const banner = banner;
      window.matchMedia('(max-width: 536px)').matches ? banner.style.backgroundImage = 'url(' + banner.dataset.mobile + ')' : banner.style.backgroundImage = 'url(' + banner.dataset.desktop + ')';
    }

    responsiveBanner();

    window.addEventListener('resize', () => responsiveBanner());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buying-guide-experience"] && !Shopify.designMode) return;
  try {
    
  // Affirm
  _affirm_config = {
    // public_api_key:  "YOUR_PUBLIC_KEY",
    // script:          "https://cdn1-sandbox.affirm.com/js/v2/affirm.js"
    public_api_key:  "6AB11R91UAKC1CE8",
  script:          "https://cdn1.affirm.com/js/v2/affirm.js"
  };
  (function(l,g,m,e,a,f,b){var d,c=l[m]||{},h=document.createElement(f),n=document.getElementsByTagName(f)[0],k=function(a,b,c){return function(){a[b]._.push([c,arguments])}};c[e]=k(c,e,"set");d=c[e];c[a]={};c[a]._=[];d._=[];c[a][b]=k(c,a,b);a=0;for(b="set add save post open empty reset on off trigger ready setProduct".split(" ");a<b.length;a++)d[b[a]]=k(c,e,b[a]);a=0;for(b=["get","token","url","items"];a<b.length;a++)d[b[a]]=function(){};h.async=!0;h.src=g[f];n.parentNode.insertBefore(h,n);delete g[f];d(g);l[m]=c})(window,_affirm_config,"affirm","checkout","ui","script","ready");
  // Use your live public API Key and https://cdn1.affirm.com/js/v2/affirm.js script to point to Affirm production environment.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-listing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const List = document.querySelector('.category-container').children;
    const button = document.querySelector('.see-more-items');
    let activeItems, itemsLength = List.length - 1;

    const responsiveNews = function () {
      if (itemsLength > 6) {
        if (window.innerWidth <= 640) {
          activeItems = 2;
          Array.from(List).forEach(item => item.classList.remove('active-item'));
          document.querySelector('.category-container').children[activeItems].classList.add('active-item');
        } else {
          activeItems = 6;
          Array.from(List).forEach(item => item.classList.remove('active-item'));
          document.querySelector('.category-container').children[activeItems - 1].classList.add('active-item');
        }
      }
    }

    window.addEventListener('load', function(){
      responsiveNews();

      button.addEventListener('click', function() {
        activeItems += 2;  
        activeItems == itemsLength ? this.classList.add('hide-button') : this.classList.remove('hide-button');

        Array.from(List).forEach(item => item.classList.remove('active-item'));
        this.parentNode.previousElementSibling.children[activeItems].classList.add('active-item');
      });
    });

    window.addEventListener('resize', function(){
      responsiveNews();
      button.classList.remove('hide-button');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-banner"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const responsiveBanner = function() {
      const banner = document.querySelector('.collection-banner-container');
      window.matchMedia('(max-width: 536px)').matches ? banner.style.backgroundImage = 'url(' + banner.dataset.mobile + ')' : banner.style.backgroundImage = 'url(' + banner.dataset.desktop + ')';
    }

    responsiveBanner();

    window.addEventListener('resize', () => responsiveBanner());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-collections"]) return;
  try {
    
  (function () {
    const buttonRight = document.querySelector('.js-click-to-hscroll.scroll-right');
    const buttonLeft = document.querySelector('.js-click-to-hscroll.scroll-left');

    function slide(direction){
      var container = document.querySelector('.js-list-scroll');
      scrollCompleted = 0;
      var slideVar = setInterval(function(){
        if(direction == 'left'){
          container.scrollLeft -= 20;
          buttonRight.classList.remove('hidden');
        } else {
          container.scrollLeft += 20;
          buttonLeft.classList.remove('hidden');
        }
        toggleArrow(container, direction);
        scrollCompleted += 20;
        
        if(scrollCompleted >= 200){
          window.clearInterval(slideVar);
        }
      }, 50);
    }

    buttonRight.onclick = function () {
      slide('right');
    };
    buttonLeft.onclick = function () {
      slide('left');
    };

    function toggleArrow(container, dir) {
      const scrollWidth = container.scrollWidth, width = container.offsetWidth, scrollLeft = container.scrollLeft;
      const offsetRight = 0;
      const offsetLeft = scrollWidth;
      const widthScrollRight = scrollWidth - scrollLeft - width;
      const widthScrollLeft = scrollWidth - scrollLeft;

      if (dir == 'right' && widthScrollRight == offsetRight) {
        buttonRight.classList.add('hidden');
      }
      if (dir == 'left' && widthScrollLeft == offsetLeft) { 
        buttonLeft.classList.add('hidden');
      }
    } 
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-frames"]) return;
  try {
    
  (function () {
    const backToList = document.querySelector('.back-to-list');
    const backToListTouch = document.querySelector('.back-to-list-touch');
    const showSmartLineup = document.querySelector('.show-smart-frames');
    const showTouchLineup = document.querySelector('.show-touch-frames');

    showSmartLineup.addEventListener('click', function() {
      toggleBlock();  
    });

    showTouchLineup.addEventListener('click', function() {
      toggleTouchBlock();  
    });

    backToList.addEventListener('click', function() {
      toggleBlock();      
    });

    backToListTouch.addEventListener('click', function() {
      toggleTouchBlock();      
    });

    function toggleBlock() { 
      const blocks = document.querySelectorAll('.frame-block');
      blocks.forEach(block => { 
        block.classList.toggle('active');
      });
    }
    function toggleTouchBlock() { 
      const blocks = document.querySelectorAll('.frame-touch-block');
      blocks.forEach(block => { 
        block.classList.toggle('active');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-qa"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const apiKey = document.querySelector('.contact-question-and-answer-container').dataset.api;
    const secretKey = document.querySelector('.contact-question-and-answer-container').dataset.secret;
    const list = document.querySelector('#contact-questions-container').children;

    let activeItems = 4, userToken = '';

    list[4].classList.add('active-items');

    document.querySelector('#show-more-question').addEventListener('click', function() {
      activeItems += 4;

      Array.from(list).forEach(item => item.classList.remove('active-items'));

      if (activeItems >= list.length - 1) {
        this.style.display = 'none';
      }
  
      this.previousElementSibling.children[activeItems].classList.add('active-items');
    });

    document.querySelectorAll('.accordion .item').forEach(item => {
      item.children[1].addEventListener('change', () => item.children[1].previousElementSibling.classList.toggle('active'));
    });

    async function getUserToken (api_key, secret_key) {
      try {
        const response = await fetch('https://api.yotpo.com/oauth/token', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            'client_id': api_key,
            'client_secret': secret_key,
            'grant_type': 'client_credentials'
          })
        });

        const content = await response.json();

        userToken = content.access_token;
      } catch (error) {
        console.log(error);
      }
    }

    async function loadQuestionsAndAnswer (user_token, api_key) {
      try {
        const response = await fetch(`https://api.yotpo.com/apps/app_key/questions.json?app_key=${api_key}&utoken=${user_token}`, { method: "GET", headers: { "Accept": 'application/json', "Content-Type": 'application/json' } });

        const content = await response.json();

        if (content.status.code === 200) {
          const initialQuestions = content.response.questions;

          let output = '';

          initialQuestions.forEach((item, index) => {

            let monthArray, createdAt, createdAtDate, createdAtMonth, createdDate, firstAnswer, asker, question;

            monthArray = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
            createdAt = item.created_at.split('T');
            createdAtDate = createdAt[0].split('-');
            createdAtMonth = createdAtDate[1].replace('0', '');
            createdDate = monthArray[Number(createdAtMonth) - 1] + ' ' +createdAtDate[2] + ', ' + createdAtDate[0];
            asker = item.asker.display_name;
            question = item.content;

            if (item.answers.length > 0) {
              firstAnswer = item.answers[0].content;
            } else {
              firstAnswer = 'No available answer yet.';
            }

            output += `
              <div class="item py-12 md:py-16 border-b relative">
                <label for="item-page-${index}" class="text-xl md:text-3xl font-semibold block pr-14 cursor-pointer">${question}</label>
                <input type="checkbox" id="item-page-${index}" class="hidden">
                <div class="content text-2xl md:text-3xl mt-6 w-full md:w-7/12">
                  <small class="block text-xl mb-10">Asked on ${createdDate} by ${asker}</small>
                  ${firstAnswer}
                </div>
              </div>
            `;
          });

          document.querySelector('#contact-questions-container').insertAdjacentHTML('beforeend', output);
        }
      } catch (error) {
        console.log(error);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["corporate-gifting"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const responsiveBanner = function(){
      const banner = document.querySelector('.corporate-gifting-banner-container')
      window.matchMedia('(max-width: 479px)').matches ? banner.style.backgroundImage = 'url(' + banner.dataset.mobile + ')' :  banner.style.backgroundImage = 'url(' + banner.dataset.desktop + ')';
    }

    responsiveBanner();

    window.addEventListener('resize', () => responsiveBanner());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-reimagined"]) return;
  try {
    
  (function(){
    checkJquery = function() { if(window.$) { countrySelectKeyup() } else { window.setTimeout(checkJquery, 1000) } }
    document.addEventListener('DOMContentLoaded', function() { checkJquery(); });

    document.querySelectorAll('.toggle-menu h4').forEach(item => { 
      const icon = item.querySelector('.accordion-icon')
      item.addEventListener('click', () => {

        item.classList.toggle('active');
        if(icon) {
          icon.classList.toggle('open');
        }
        item.nextElementSibling.classList.toggle('active');
      });
    });  
    document.querySelector('.select-country').addEventListener('click', function() {
        this.children[0].classList.toggle('hidden');
        if (this.children[0].dataset.visibility == 'false') {
            this.children[0].dataset.visibility = true;
            document.querySelector('body').classList.add('country-overflow-hidden'); 
        } else {
            this.children[0].dataset.visibility = false;
            document.querySelector('body').classList.remove('country-overflow-hidden'); 
        }
    }); 
    document.querySelector('.select-country-mob').addEventListener('click', function() {this.children[0].classList.toggle('hidden'); });
    document.querySelectorAll('.list-of-country li').forEach(item => { item.addEventListener('mouseover', () => { document.querySelectorAll('.list-of-country li').forEach(e => e.classList.remove('selected'));  item.classList.add('selected'); });});

    var countrySelectKeyup = function() { 
        (function($){
            document.addEventListener('keyup', (event) => {
                event.stopPropagation(); 
                if (document.querySelector('.list-of-country').dataset.visibility == 'true') {
                    if (event.key == 'ArrowUp') {
                        event.preventDefault();
                        var selected = $(".list-of-country .selected");
                        $(".list-of-country li").removeClass("selected");
                        if (selected.prev().length == 0) { selected.siblings().last().addClass("selected"); } else { selected.prev().addClass("selected"); }
                    }
                    if (event.key == 'ArrowDown') {
                        event.preventDefault();
                        var selected = $(".list-of-country .selected");
                        $(".list-of-country li").removeClass("selected");
                        if (selected.next().length == 0) { selected.siblings().first().addClass("selected"); } else { selected.next().addClass("selected"); }
                    }
                    if (event.key == 'Enter') {$(".list-of-country .selected a")[0].click(); }
                }
            })
        })(window.$);
    }
  })();
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-v2"]) return;
  try {
    
  (function(){
    checkJquery = function() { if(window.$) { countrySelectKeyup() } else { window.setTimeout(checkJquery, 1000) } }
    document.addEventListener('DOMContentLoaded', function() { checkJquery(); });

    document.querySelectorAll('.toggle-menu h4').forEach(item => { 
      const icon = item.querySelector('.accordion-icon')
      item.addEventListener('click', () => {

        item.classList.toggle('active');
        if(icon) {
          icon.classList.toggle('open');
        }
        item.nextElementSibling.classList.toggle('active');
      });
    });  
    document.querySelector('.select-country').addEventListener('click', function() {
        this.children[0].classList.toggle('hidden');
        if (this.children[0].dataset.visibility == 'false') {
            this.children[0].dataset.visibility = true;
            document.querySelector('body').classList.add('country-overflow-hidden'); 
        } else {
            this.children[0].dataset.visibility = false;
            document.querySelector('body').classList.remove('country-overflow-hidden'); 
        }
    }); 
    document.querySelector('.select-country-mob').addEventListener('click', function() {this.children[0].classList.toggle('hidden'); });
    document.querySelectorAll('.list-of-country li').forEach(item => { item.addEventListener('mouseover', () => { document.querySelectorAll('.list-of-country li').forEach(e => e.classList.remove('selected'));  item.classList.add('selected'); });});

    var countrySelectKeyup = function() { 
        (function($){
            document.addEventListener('keyup', (event) => {
                event.stopPropagation(); 
                if (document.querySelector('.list-of-country').dataset.visibility == 'true') {
                    if (event.key == 'ArrowUp') {
                        event.preventDefault();
                        var selected = $(".list-of-country .selected");
                        $(".list-of-country li").removeClass("selected");
                        if (selected.prev().length == 0) { selected.siblings().last().addClass("selected"); } else { selected.prev().addClass("selected"); }
                    }
                    if (event.key == 'ArrowDown') {
                        event.preventDefault();
                        var selected = $(".list-of-country .selected");
                        $(".list-of-country li").removeClass("selected");
                        if (selected.next().length == 0) { selected.siblings().first().addClass("selected"); } else { selected.next().addClass("selected"); }
                    }
                    if (event.key == 'Enter') {$(".list-of-country .selected a")[0].click(); }
                }
            })
        })(window.$);
    }
  })();
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-v3"]) return;
  try {
    
  (function(){
    checkJquery = function() { if(window.$) { countrySelectKeyup() } else { window.setTimeout(checkJquery, 1000) } }
    document.addEventListener('DOMContentLoaded', function() { checkJquery(); });

    document.querySelectorAll('.toggle-menu h4').forEach(item => { 
      const icon = item.querySelector('.accordion-icon')
      item.addEventListener('click', () => {

        item.classList.toggle('active');
        if(icon) {
          icon.classList.toggle('open');
        }
        item.nextElementSibling.classList.toggle('active');
      });
    });  
    document.querySelector('.select-country').addEventListener('click', function() {
        this.children[0].classList.toggle('hidden');
        if (this.children[0].dataset.visibility == 'false') {
            this.children[0].dataset.visibility = true;
            document.querySelector('body').classList.add('country-overflow-hidden'); 
        } else {
            this.children[0].dataset.visibility = false;
            document.querySelector('body').classList.remove('country-overflow-hidden'); 
        }
    }); 
    if (document.querySelector('.select-country-mob')) {
      document.querySelector('.select-country-mob').addEventListener('click', function() {this.children[0].classList.toggle('hidden'); });
    }
    document.querySelectorAll('.list-of-country li').forEach(item => { item.addEventListener('mouseover', () => { document.querySelectorAll('.list-of-country li').forEach(e => e.classList.remove('selected'));  item.classList.add('selected'); });});

    var countrySelectKeyup = function() { 
        (function($){
            document.addEventListener('keyup', (event) => {
                event.stopPropagation(); 
                if (document.querySelector('.list-of-country').dataset.visibility == 'true') {
                    if (event.key == 'ArrowUp') {
                        event.preventDefault();
                        var selected = $(".list-of-country .selected");
                        $(".list-of-country li").removeClass("selected");
                        if (selected.prev().length == 0) { selected.siblings().last().addClass("selected"); } else { selected.prev().addClass("selected"); }
                    }
                    if (event.key == 'ArrowDown') {
                        event.preventDefault();
                        var selected = $(".list-of-country .selected");
                        $(".list-of-country li").removeClass("selected");
                        if (selected.next().length == 0) { selected.siblings().first().addClass("selected"); } else { selected.next().addClass("selected"); }
                    }
                    if (event.key == 'Enter') {$(".list-of-country .selected a")[0].click(); }
                }
            })
        })(window.$);
    }
  })();
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function(){
    document.querySelectorAll('.toggle-menu h4').forEach(item => { 
      item.addEventListener('click', () => {
        item.classList.toggle('active'); 
        item.nextElementSibling.classList.toggle('active');
      });
    });

    document.querySelector('.country-selector').addEventListener('click', function() {
      this.children[0].classList.toggle('hidden');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frames-bundle-banner"] && !Shopify.designMode) return;
  try {
    
  const getTimeRemaining = (endtime) => {
    const t = Date.parse(endtime) - Date.parse(new Date()), 
          seconds = Math.floor((t / 1000) % 60), 
          minutes = Math.floor((t / 1000 / 60) % 60), 
          hours = Math.floor((t / (1000 * 60 * 60)) % 24),
          days = Math.floor(t / (1000 * 60 * 60 * 24));

    return {
      'total': t,
      'days': days,
      'hours': hours,
      'minutes': minutes,
      'seconds': seconds
    };
  }

  const deadline = document.querySelector('#frames-bundle-deadline').value;

  const doOften = () => {
    window.requestAnimationFrame(doOften);
    const timeleft = getTimeRemaining(deadline);
    const elements = Array.from(document.querySelectorAll('.new-time-left'));

    let hoursText, minsText, secsText, wordDays, separator, socialDays, socialHours, socialMinutes, socialSeconds;
    
    for( let i in elements) {
      hoursText = 'Hours';
      minsText = 'Mins';
      secsText = 'Secs';
      wordDays = (timeleft.days > 1)? 'Days': 'Day';

      separator = "<span class='separator mx-4 inline-block relative -top-14'> : </span>"
      socialDays = (timeleft.days > 0)? `<span class="time_item inline-block uppercase"><span class="block bg-black py-4 px-6 rounded-xl">${timeleft.days} </span>  <small class="tracking-wide">${wordDays}</small></span> ${separator}`: '';
      socialHours =  `<span class="time_item inline-block uppercase"><span class="block bg-black py-4 px-6 rounded-xl">${timeleft.hours}</span> <small class="tracking-wide">${hoursText}</small></span> ${separator}`;
      socialMinutes = `<span class="time_item inline-block uppercase"><span class="block bg-black py-4 px-6 rounded-xl">${timeleft.minutes}</span> <small class="tracking-wide">${minsText}</small></span> ${separator}`;
      socialSeconds =  `<span class="time_item inline-block uppercase"><span class="block bg-black py-4 px-6 rounded-xl">${timeleft.seconds}</span> <small class="tracking-wide">${secsText}</small></span>`;
      elements[i].innerHTML =` ${socialDays}  ${socialHours} ${socialMinutes} ${socialSeconds}`;
    }
  }

  doOften();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frames-plus-navigation"]) return;
  try {
    
	(function(){
		window.addEventListener('scroll', () => {
			const scroll = document.documentElement.scrollTop; 
			scroll > 200 ? document.querySelector('.frames-plus-navigation-container').classList.add('sticked') : document.querySelector('.frames-plus-navigation-container').classList.remove('sticked');
		});
	
		const toggleProductSubMenu = function(){
			if(window.innerWidth <= 1025){
				const burger = document.querySelector('.frames-plus-navigation-container .burger');
				burger.addEventListener('click', function(){
					this.parentNode.parentNode.parentNode.children[0].children[1].classList.toggle('hidden');    
				});
			}
		} 
	
		window.addEventListener('load', () => toggleProductSubMenu());
		window.addEventListener('resize', () => toggleProductSubMenu());
	})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-main-banner"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const responsiveBanner = function() {
      document.querySelectorAll('.main-home-banner').forEach(item => {    
        window.matchMedia('(max-width: 536px)').matches ? item.style.backgroundImage = 'url(' + item.dataset.mobile + ')' : item.style.backgroundImage = 'url(' + item.dataset.desktop + ')';  
      });  
    }
    responsiveBanner();
    window.addEventListener('resize', () => responsiveBanner());
  })();

  /**
  document.addEventListener("DOMContentLoaded", function() {
    const onLoadInterval = document.querySelector('.main-home-banner-container .slider-container li').dataset.interval;
    document.querySelector('.main-home-banner-container .swiffy-slider').dataset.sliderNavAutoplayInterval = onLoadInterval;
    
    document.querySelectorAll('.main-home-banner-container .slider-container li').forEach(item => { 
      const btn = document.querySelector('.slider-container')
      const options = {
        attributes: true
      }

      function callback(mutationList, observer) {
        mutationList.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if(item.classList.contains('slide-visible')) { 
              console.log(`The name is ${mutation.target.dataset.interval}`) 
              document.querySelector('.main-home-banner-container .swiffy-slider').dataset.sliderNavAutoplayInterval = mutation.target.dataset.interval;
            } 
          }
        })
      }
      const observer = new MutationObserver(callback);
      observer.observe(item, options);
    });
  });
  **/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-nix-circles-banner"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const responsiveBanner = function() {
      document.querySelectorAll('.nix-circles-banner').forEach(item => {    
        window.matchMedia('(max-width: 536px)').matches ? item.style.backgroundImage = 'url(' + item.dataset.mobile + ')' : item.style.backgroundImage = 'url(' + item.dataset.desktop + ')';
      });  
    }
    responsiveBanner();
    window.addEventListener('resize', () => responsiveBanner());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-printed-gift-store-banner"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const responsiveBanner = function() {
      document.querySelectorAll('.printed-gift-store-banner').forEach(item => {    
        window.matchMedia('(max-width: 536px)').matches ? item.style.backgroundImage = 'url(' + item.dataset.mobile + ')' : item.style.backgroundImage = 'url(' + item.dataset.desktop + ')';
      });  
    }
    responsiveBanner();
    window.addEventListener('resize', () => responsiveBanner());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-trust-nixplay-banner"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const responsiveBanner = function() {
      document.querySelectorAll('.trust-nixplay-banner').forEach(item => {    
        window.matchMedia('(max-width: 536px)').matches ? item.style.backgroundImage = 'url(' + item.dataset.mobile + ')' : item.style.backgroundImage = 'url(' + item.dataset.desktop + ')';
      });  
    }
    responsiveBanner();
    window.addEventListener('resize', () => responsiveBanner());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-usp-banner-column"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const responsiveBanner = function() {
      document.querySelectorAll('.home-usp-banner-column').forEach(item => {    
        window.matchMedia('(max-width: 536px)').matches ? item.style.backgroundImage = 'url(' + item.dataset.mobile + ')' : item.style.backgroundImage = 'url(' + item.dataset.desktop + ')';
      });  
    }
    responsiveBanner();
    window.addEventListener('resize', () => responsiveBanner());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legal-modal"]) return;
  try {
    
  (function(){
    async function loadContent(params) {
      try {
        if (params.href.includes('iubenda')) {
          const response = await fetch(params.href);
          const data  = await response.json();
          const content = data.content;
          document.querySelector('.loader').classList.add('hidden');
          document.querySelector('#content').innerHTML = String(content);   
        } else {
          const response = await fetch(params.href, { headers: { "Accept": "text/plain" } });
          // const content  = await response.json();
          const content  = await response.text();
          document.querySelector('.loader').classList.add('hidden');
        document.querySelector('#content').innerHTML = content;   
        }

        

      } catch (error) {
        console.log(error);
      }
    }

    document.querySelectorAll('.impressum-country').forEach(item => {
      item.addEventListener('click', e => {
        e.preventDefault();
        document.querySelector('.modal-overlay').classList.remove('hidden');
        document.querySelector('.legal-modal').classList.remove('hidden');
        document.querySelector('body').classList.add('overflow-y-hidden');

        loadContent(item);
      });
    });

    const closeModal = function (selector) {
      selector.addEventListener('click', () => {
        document.querySelector('.modal-overlay').classList.add('hidden');
        document.querySelector('.legal-modal').classList.add('hidden');
        document.querySelector('.loader').classList.remove('hidden');
        document.querySelector('body').classList.remove('overflow-y-hidden');
        document.querySelector('#content').innerHTML = '';
      });
    }

    closeModal(document.querySelector('.modal-close')); 
    closeModal(document.querySelector('.modal-overlay'));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membership-banner"] && !Shopify.designMode) return;
  try {
    
  const addToCartButton = document.querySelectorAll('.membership-banner-column-container button');

  addToCartButton.forEach(item => {
    item.addEventListener('click', () => {
      addToCartButton.forEach(btn => btn.classList.add('disabled'));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-app"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const responsiveBanner = function(){
      const banner = document.querySelector('.mobile-app-banner-container');
      window.matchMedia('(max-width: 479px)').matches ? banner.style.backgroundImage = 'url(' + banner.dataset.mobile + ')' :  banner.style.backgroundImage = 'url(' + banner.dataset.desktop + ')';
    }

    responsiveBanner();

    window.addEventListener('resize', () => responsiveBanner());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["print-banner"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const responsiveBanner = function(){
      const banner = document.querySelector('.print-banner-container');
      window.matchMedia('(max-width: 536px)').matches ? banner.style.backgroundImage = 'url(' + banner.dataset.mobile + ')' : banner.style.backgroundImage = 'url(' + banner.dataset.desktop + ')';
    }
  
    responsiveBanner();

    window.addEventListener('resize', () => responsiveBanner());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["print-category"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const siblings = element => [...element.parentElement.children].filter(next => next != element);
    
    document.querySelectorAll('.category-tab').forEach(item => {
      item.addEventListener('click', () => {
        Array.from(item.parentElement.parentElement.nextElementSibling.children).forEach(element => item.dataset.category == element.dataset.category ? element.style.display = 'block' : element.style.display = 'none');
        siblings(item).forEach(el => el.classList.remove('active'));
        item.classList.add('active');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["print-compare"] && !Shopify.designMode) return;
  try {
    
  (function(){
    let active, limit;

    active = 2;
    limit = 4;

    document.querySelector('.print-compare-container .btn-next').addEventListener('click', function() {
      if (active < limit) {
        active++;
        console.log(active);
        document.querySelectorAll('.print-compare-container td[data-column]').forEach(element => element.classList.add('hide-td'));
        document.querySelectorAll(`.print-compare-container td[data-column="${active}"]`).forEach(element => element.classList.remove('hide-td'));
        document.querySelectorAll(`.print-compare-container td[data-column="${active}"]`).forEach(element => element.classList.add('show-td'));
      }
    });

    document.querySelector('.print-compare-container .btn-prev').addEventListener('click', function() {
      if (active > 2) {
        active--;
        console.log(active);
        document.querySelectorAll('.print-compare-container td[data-column]').forEach(element => element.classList.add('hide-td'));
        document.querySelectorAll(`.print-compare-container td[data-column="${active}"]`).forEach(element => element.classList.remove('hide-td'));
        document.querySelectorAll(`.print-compare-container td[data-column="${active}"]`).forEach(element => element.classList.add('show-td'));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["print-offers-banner-middle"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const responsiveBanner = function() {
      const banner = document.querySelector('.print-offer-middle-banner')
      window.matchMedia('(max-width: 536px)').matches ? banner.style.backgroundImage = 'url(' + banner.dataset.mobile + ')' : banner.style.backgroundImage = 'url(' + banner.dataset.desktop + ')';
    }

    responsiveBanner();

    window.addEventListener('resize', () => responsiveBanner());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["print-offers-banner"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const responsiveBanner = function() {
      const banner = document.querySelector('.print-offer-container')
      window.matchMedia('(max-width: 536px)').matches ? banner.style.backgroundImage = 'url(' + banner.dataset.mobile + ')' : banner.style.backgroundImage = 'url(' + banner.dataset.desktop + ')';
    }

    responsiveBanner();

    window.addEventListener('resize', () => responsiveBanner());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["print-products"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.product-item').forEach(item => {
      const totalPrice = +item.children[1].children[1].children[0].dataset.price - +item.children[1].children[1].dataset.discount;
      item.children[1].children[2].innerText = 'Save $' + totalPrice.toFixed(2);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["print-small-banner"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const responsiveBanner = function() {
      const banner = document.querySelector('.print-small-banner-container');
      window.matchMedia('(max-width: 536px)').matches ? banner.style.backgroundImage = 'url(' + banner.dataset.mobile + ')' : banner.style.backgroundImage = 'url(' + banner.dataset.desktop + ')';
    }

    responsiveBanner();

    window.addEventListener('resize', () => responsiveBanner());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["printed-gift-store-banner"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const responsiveBanner = function() {
      const banner = document.querySelector('.printed-gift-banner');
      window.matchMedia('(max-width: 536px)').matches ? banner.style.backgroundImage = 'url(' + banner.dataset.mobile + ')' : banner.style.backgroundImage = 'url(' + banner.dataset.desktop + ')';
    }

    responsiveBanner();

    window.addEventListener('resize', () => responsiveBanner());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-local-reviews"] && !Shopify.designMode) return;
  try {
    
  window.onload = function (){
    const fetchReviews = document.querySelector('.product-reviews-container').dataset.reviews;
    const title = document.querySelector('.product-reviews-container').dataset.title;
    const loadMore = document.querySelector('#show-more-reviews');

    const loadMoreReviews = () => {
      let currentItems = 3;

      loadMore.addEventListener('click', (e) => {
        const elementList = [...document.querySelectorAll('#review-listing .item')];
        for (let i = currentItems; i < currentItems + 3; i++) {
          if (elementList[i]) {
            elementList[i].style.display = 'block';
          }
        }

        currentItems += 3;

        if (currentItems >= elementList.length) {
          event.target.style.display = 'none';
        }
      });
    }

    async function displayLocalProductReviews () {
      try {
        const response = await fetch(fetchReviews);
        const content  = await response.json();

        let output = '';
        let totalReviews = 0;
        let averageScore = 0;
        let oneStar = 0;
        let twoStar = 0;
        let threeStar = 0;
        let fourStar = 0;
        let fiveStar = 0;

        let allMatchedReviews = [];
        let allMatchedScores = [];
        
        content.forEach(item => {
          if (item.published === 'Yes' && item.product_name === title) {
            allMatchedReviews.push(item);
            allMatchedScores.push(item.score);
          }
        });

        allMatchedReviews.slice(0, 50).forEach(item => {
          let reviewer, title, content, score;

          first_name = item.first_name;
          last_name = item.last_name;
          title    = item.title;
          content  = item.content;
          score    = item.score;
          
          output += `
            <div class="item py-10 md:py-12 px-10 md:px-16 mb-12">
              <div class="block md:flex justify-start">
                <div class="name mr-14 font-semibold mb-10 md:mb-0 capitalize">
                  ${first_name} ${last_name}${last_name ? '.' : ''}
                </div>
                <div class="content">
                  <svg xmlns="http://www.w3.org/2000/svg"  class='inline-block w-32' viewBox="0 0 128 24">
                    <def>
                      <path id="yellowStar" d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z" />
                    </def>
                    <use href="#yellowStar" y="0" fill="${score >= 1 ? '#D9AE31' : '#e2e2e2'}"/> 
                    <use href="#yellowStar" x="26" y="0" fill="${score >= 2 ? '#D9AE31' : '#e2e2e2'}"/>
                    <use href="#yellowStar" x="52" y="0" fill="${score >= 3 ? '#D9AE31' : '#e2e2e2'}"/>
                    <use href="#yellowStar" x="78" y="0" fill="${score >= 4 ? '#D9AE31' : '#e2e2e2'}"/>
                    <use href="#yellowStar" x="104" y="0"  fill="${score >= 4.7 ? '#D9AE31' : '#e2e2e2'}"/>
                  </svg>
                  <div class="leading-loose font-light mt-10">
                    <p class="font-medium">${title}</p>
                    ${content}
                  </div>
                </div>
              </div>
            </div>
          `;
        });

        document.querySelector('#review-listing').insertAdjacentHTML('afterbegin', output);

        allMatchedScores.forEach(item => {
          totalReviews += 1;
          averageScore += parseInt(item);

          if (item == 1) {
            oneStar += 1;
          } else if (item == 2) {
            twoStar += 1;
          } else if (item == 3) {
            threeStar += 1;
          } else if (item == 4) {
            fourStar += 1;
          } else if (item == 5) {
            fiveStar += 1;
          }
        });

        let getAverageScore = (averageScore / totalReviews).toFixed(1);
        let finalAverageScore = 0;

        getAverageScore.includes('.0') ? finalAverageScore = getAverageScore.toString().split('.')[0] : finalAverageScore = getAverageScore;

        document.querySelector('#five-stars').style.width = (fiveStar / totalReviews) * 100 + '%';
        document.querySelector('#four-stars').style.width = (fourStar / totalReviews) * 100 + '%';
        document.querySelector('#three-stars').style.width = (threeStar / totalReviews) * 100 + '%';
        document.querySelector('#two-stars').style.width = (twoStar / totalReviews) * 100 + '%';
        document.querySelector('#one-stars').style.width = (oneStar / totalReviews) * 100 + '%';
        
        document.querySelector('#total-reviews').innerText = totalReviews;
        document.querySelector('#average-score').innerText = finalAverageScore;
      } catch (error) {
        console.log(error);
      }
    }

    displayLocalProductReviews();
    loadMoreReviews();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-other-products"]) return;
  try {
    
  if (document.querySelector('.hide-section-1') != null) {
    document.querySelector('.hide-section-1').parentNode.classList.add('hidden'); 
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-qa"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const loadMore = document.querySelector('#show-more-question');

    const loadMoreQuestions = () => {
      let currentItems = 2;

      loadMore.addEventListener('click', (e) => {
        const elementList = [...document.querySelectorAll('.accordion .item')];
        for (let i = currentItems; i < currentItems + 2; i++) {
          if (elementList[i]) {
            elementList[i].style.display = 'block';
          }
        }

        currentItems += 2;

        if (currentItems >= elementList.length) {
          event.target.style.display = 'none';
        }
      });
    }

    loadMoreQuestions();

    document.querySelectorAll('.accordion .item').forEach(item => {
      item.children[1].addEventListener('change', () => item.children[1].previousElementSibling.classList.toggle('active'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const product = document.querySelector('.product-reviews-container');
    const apiKey = product.dataset.api;
    const showMoreButton = document.querySelector('#show-more-reviews');
    const productReviewsContainer = document.querySelector('.product-reviews');

    const productDetails = {
      id: product.dataset.id,
      sku: product.dataset.sku
    }

    let pageLimit, pageNumber = 1;

    async function displayProductReviewsBottomLine (id, api_key) {
      try {
        const response = await fetch(`https://api.yotpo.com/products/${api_key}/${id}/bottomline`, { method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } } );
        const content  = await response.json();
  
        if(content.status.code == 200) {
          document.querySelector('#average-score').innerHTML = content.response.bottomline.average_score;
          document.querySelector('#total-reviews').innerHTML = content.response.bottomline.total_reviews;
        }
      } catch (error){
        console.log(error);
      }
    }
  
    async function displayProductReviews (id, page, api_key) {
      try {
        const response = await fetch(`https://api.yotpo.com/v1/widget/${api_key}/products/${id}/reviews.json?page=${page}`, { method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } } );
        const content  = await response.json();

        if(content.status.code == 200){
          const reviews  = content.response.reviews;
          const totalReviews = content.response.bottomline.total_review;
    
          const paginationPerPage  = content.response.pagination.per_page;
          const paginationTotal    = content.response.pagination.total;
          const starsDistribution = content.response.bottomline.star_distribution;

          if(starsDistribution != null){
            const arrayStarsDistribution = Object.entries(starsDistribution);

            const fiveStar = arrayStarsDistribution[4];
            const fourStar = arrayStarsDistribution[3];
            const threeStar = arrayStarsDistribution[2];
            const twoStar = arrayStarsDistribution[1];
            const oneStar = arrayStarsDistribution[0];

            document.querySelector('#five-stars').style.width = (fiveStar[1] / totalReviews) * 100 + '%';
            document.querySelector('#four-stars').style.width = (fourStar[1] / totalReviews) * 100 + '%';
            document.querySelector('#three-stars').style.width = (threeStar[1] / totalReviews) * 100 + '%';
            document.querySelector('#two-stars').style.width = (twoStar[1] / totalReviews) * 100 + '%';
            document.querySelector('#one-stars').style.width = (oneStar[1] / totalReviews) * 100 + '%';
          }

          pageLimit = Math.ceil(paginationTotal / paginationPerPage);   

          if (pageNumber >= pageLimit) {
            showMoreButton.setAttribute('disabled', 'disabled');
            showMoreButton.innerText = showMoreButton.dataset.disabled;
          }

          if(reviews.length === 0) {
            productReviewsContainer.classList.add('no-reviews');
            productReviewsContainer.insertAdjacentHTML('afterbegin', productReviewsContainer.dataset.noreviews);
  
            document.querySelector('#review-listing').classList.add('hidden');
            showMoreButton.style.display = 'none';

            document.querySelector('#shopify-section-product-reviews').classList.add('hidden'); 
          }

          let output = '';
    
          reviews.forEach(review => {
            let reviewer, title, content, score;
    
            reviewer = review.user.display_name;
            title    = review.title;
            content  = review.content;
            score    = review.score;
    
            output += `
              <div class="item block md:flex justify-start py-16 px-8 md:p-x16 mb-12" style="background-color: #fafafa;">
                <div class="name mr-14 font-semibold mb-10 md:mb-0">
                  ${reviewer}
                </div>
                <div class="content">
                  <svg xmlns="http://www.w3.org/2000/svg"  class='inline-block w-32' viewBox="0 0 128 24">
                    <def>
                      <path id="yellowStar" d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z" />
                    </def>
                    <use href="#yellowStar" y="0" fill="${score >= 1 ? '#D9AE31' : '#e2e2e2'}"/>
                    <use href="#yellowStar" x="26" y="0" fill="${score >= 2 ? '#D9AE31' : '#e2e2e2'}"/>
                    <use href="#yellowStar" x="52" y="0" fill="${score >= 3 ? '#D9AE31' : '#e2e2e2'}"/>
                    <use href="#yellowStar" x="78" y="0" fill="${score >= 4 ? '#D9AE31' : '#e2e2e2'}"/>
                    <use href="#yellowStar" x="104" y="0"  fill="${score >= 4.7 ? '#D9AE31' : '#e2e2e2'}"/>
                  </svg>
                  <div class="leading-loose font-light mt-10">
                    <p class="font-medium">${title}</p>
                    ${content}
                  </div>
                </div>
              </div>
            `;
          });
    
          document.querySelector('#review-listing').insertAdjacentHTML('beforebegin', output);
        } else if (content.status.code == 404) { 
          document.querySelector('#shopify-section-product-reviews').classList.add('hidden');
        } else {
          productReviewsContainer.classList.add('no-reviews');
          productReviewsContainer.insertAdjacentHTML('afterbegin', productReviewsContainer.dataset.noreviews);

          document.querySelector('#review-listing').classList.add('hidden');
          showMoreButton.style.display = 'none';
        }
      } catch (error) {
        console.log(error);
      }
    }
  
    showMoreButton.addEventListener('click', function () {
      if (pageNumber >= pageLimit) {
        this.setAttribute('disabled', 'disabled');
        this.innerText = showMoreButton.dataset.disabled;
      }

      pageNumber++;

      displayProductReviews(productDetails.id, pageNumber, apiKey);
    });
  
    displayProductReviews(productDetails.id, pageNumber, apiKey);
    displayProductReviewsBottomLine(productDetails.id, apiKey);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-stamped-reviews-product"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', () => {
    setTimeout(() => {
      document
        .querySelectorAll('.summary-rating-title')
        .forEach((item) => (item.innerText = item.innerText.charAt(0) + ' stars'));

      const rating = document.querySelector('.stamped-summary-text-1');
      if (rating) {
        rating.innerHTML = `${rating.dataset.rating} / 5.0 `;
      }
    }, 800);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-stamped-reviews"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', () => {
    setTimeout(() => {
      document.querySelectorAll('.summary-rating-title').forEach(item => item.innerText = item.innerText.charAt(0) + ' stars')

      const rating = document.querySelector('.stamped-summary-text-1')
      rating.innerHTML = `${rating.dataset.rating} / 5 <span>(${rating.dataset.count} reviews)</span>`
    }, 800)
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seed-for-a-seed"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const responsiveBanner = function(){
      const banner = document.querySelector('.seed-for-seed-banner-container');
      window.matchMedia('(max-width: 750px)').matches ? banner.style.backgroundImage = 'url(' + banner.dataset.mobile + ')' :  banner.style.backgroundImage = 'url(' + banner.dataset.desktop + ')';
    }

    responsiveBanner();

    window.addEventListener('resize', () => responsiveBanner());

    const treeCount = { el: document.getElementById('tree-count') , start: parseInt(document.querySelector('.tree-count-container').dataset.start), end: document.querySelector('.tree-count-container').dataset.end }
    const doOften = function() {
      if(treeCount.start < treeCount.end){
        treeCount.start +=1000
        treeCount.el.innerText = `${treeCount.start.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }`
        window.requestAnimationFrame(doOften);
      }
    }

    doOften();

    document.querySelectorAll('.video-trigger').forEach(item => {
      item.addEventListener('click', function(){
        this.parentElement.nextElementSibling.lastElementChild.children[1].src = this.dataset.video;
        this.parentElement.nextElementSibling.style.display = 'block';
      });
    });
    
    document.querySelector('#close-video').addEventListener('click', function() { this.parentElement.parentElement.style.display = 'none'} );
    document.querySelector('#popup-video').addEventListener('click', function() { this.style.display = 'none'} );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sitemap"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const leftBlock = document.createElement('div');
    const rightBlock = document.createElement('div');

    Array.from(document.querySelectorAll('.block-left')).forEach(item => leftBlock.append(item));
    Array.from(document.querySelectorAll('.block-right')).forEach(item => rightBlock.append(item));

    document.querySelector('.sitemap-grid').append(leftBlock);
    document.querySelector('.sitemap-grid').append(rightBlock);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-banner"]) return;
  try {
    
  (function(){
    const responsiveBanner = function() {
      const banner = document.querySelector('.subscription-banner-container');
      window.matchMedia('(max-width: 540px)').matches ? banner.style.backgroundImage = 'url(' + banner.dataset.mobile + ')' :  banner.style.backgroundImage = 'url(' + banner.dataset.desktop + ')'
    }

    responsiveBanner();

    window.addEventListener('resize', () => responsiveBanner());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-featured-frame"]) return;
  try {
    
  (function(){
    const responsiveBanner = function(){ 
      const banner = document.querySelector('.subscription-featured-banner-container');
      window.matchMedia('(max-width: 640px)').matches ? banner.style.backgroundImage = 'url(' + banner.dataset.mobile + ')' :  banner.style.backgroundImage = 'url(' + banner.dataset.desktop + ')';
    }

    responsiveBanner();

    window.addEventListener('resize', () => responsiveBanner());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-table-features"]) return;
  try {
    
  (function(){
    document.querySelectorAll('.features-buttons button').forEach(item => {
      item.addEventListener('click', () => {
        document.querySelectorAll('.table-features td[data-column]').forEach(element => element.classList.add('hide-td'));
        document.querySelectorAll(`.table-features td[data-column="${item.dataset.trigger}"]`).forEach(element => element.classList.remove('hide-td'));
        document.querySelectorAll(`.table-features td[data-column="${item.dataset.trigger}"]`).forEach(element => element.classList.add('show-td'));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-table-printing"]) return;
  try {
    
  (function(){
    document.querySelectorAll('.print-buttons button').forEach(item => {
      item.addEventListener('click', () => {
        document.querySelectorAll('.table-print td[data-column]').forEach(element => element.classList.add('hide-td'));
        document.querySelectorAll(`.table-print td[data-column="${item.dataset.trigger}"]`).forEach(element => element.classList.remove('hide-td'));
        document.querySelectorAll(`.table-print td[data-column="${item.dataset.trigger}"]`).forEach(element => element.classList.add('show-td'));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-banner"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const responsiveBanner = function() {
      document.querySelectorAll('.main-home-banner').forEach(item => {    
        window.matchMedia('(max-width: 536px)').matches ? item.style.backgroundImage = 'url(' + item.dataset.mobile + ')' : item.style.backgroundImage = 'url(' + item.dataset.desktop + ')';  
      });  
    }
    responsiveBanner();
    window.addEventListener('resize', () => responsiveBanner());
  })();

  /**
  document.addEventListener("DOMContentLoaded", function() {
    const onLoadInterval = document.querySelector('.main-home-banner-container .slider-container li').dataset.interval;
    document.querySelector('.main-home-banner-container .swiffy-slider').dataset.sliderNavAutoplayInterval = onLoadInterval;
    
    document.querySelectorAll('.main-home-banner-container .slider-container li').forEach(item => { 
      const btn = document.querySelector('.slider-container')
      const options = {
        attributes: true
      }

      function callback(mutationList, observer) {
        mutationList.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if(item.classList.contains('slide-visible')) { 
              console.log(`The name is ${mutation.target.dataset.interval}`) 
              document.querySelector('.main-home-banner-container .swiffy-slider').dataset.sliderNavAutoplayInterval = mutation.target.dataset.interval;
            } 
          }
        })
      }
      const observer = new MutationObserver(callback);
      observer.observe(item, options);
    });
  });
  **/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-nixplay-banner"] && !Shopify.designMode) return;
  try {
    
(function(){
  const responsiveBanner = function(){
    const banner = document.querySelector('.why-nixplay-banner-container');
    window.matchMedia('(max-width: 536px)').matches ? banner.style.backgroundImage = 'url(' + banner.dataset.mobile + ')' : banner.style.backgroundImage = 'url(' + banner.dataset.desktop + ')';
  }
 
  responsiveBanner();

  window.addEventListener('resize', () => responsiveBanner());
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-nixplay-news"] && !Shopify.designMode) return;
  try {
    
  (function () {
    let newsList = document.querySelector('.news-container').children, activeNews;

    const responsiveNews = function () {
      if (window.innerWidth <= 640) {
        activeNews = 2;
        Array.from(newsList).forEach(item => item.classList.remove('active-news'));
        document.querySelector('.news-container').children[2].classList.add('active-news');
      } else {
        activeNews = 8;
        Array.from(newsList).forEach(item => item.classList.remove('active-news'));
        document.querySelector('.news-container').children[8].classList.add('active-news');
      }
    }   

    window.addEventListener('load', function(){
      responsiveNews();

      document.querySelector('.see-more-news').addEventListener('click', function(){
        activeNews += 3;
    
        Array.from(newsList).forEach(item => item.classList.remove('active-news'));
    
        this.previousElementSibling.children[activeNews].classList.add('active-news');
    
        activeNews == newsList.length - 1 ? this.classList.add('hidden') : this.classList.remove('hidden');
      });
    });

    window.addEventListener('resize', function(){
      responsiveNews();
      document.querySelector('.see-more-news').classList.remove('hidden');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-nixplay-team"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (document.querySelector('.why-nixplay-team-container').parentNode.nextElementSibling.children[0].classList.contains('hidden')) {
      document.querySelector('.why-nixplay-team-container').style.paddingBottom = '0';
    }

    const sliderContainer = document.querySelector('.team-slider-container'), sliderNext = document.querySelector('#team-slide-next'), sliderPrev = document.querySelector('#team-slide-prev');

    const responsiveSlider = function () {
      sliderContainer.style.width = 178 * sliderContainer.children.length + 'px';

      if(window.innerWidth <= 640){
        sliderContainer.dataset.active = 2;
        sliderContainer.dataset.default = 2;
      }else if(window.innerWidth <= 768){
        sliderContainer.dataset.active = 4;
        sliderContainer.dataset.default = 4;
      }else if(window.innerWidth <= 1024){
        sliderContainer.dataset.active = 6;
        sliderContainer.dataset.default = 6;
      }else if(window.innerWidth <= 1540){
        sliderContainer.dataset.active = 7;
        sliderContainer.dataset.default = 7;
      }
    } 

    const buttonAnimation = function () {
      sliderContainer.dataset.active == sliderContainer.children.length ? sliderNext.classList.add('hidden') : sliderNext.classList.remove('hidden');
      sliderContainer.dataset.active == sliderContainer.dataset.default ? sliderPrev.classList.add('hidden') : sliderPrev.classList.remove('hidden');
    }

    const slideAnimation = function (params, data) {
      if(params == 'next'){ 
        sliderContainer.dataset.slide++;
        sliderContainer.dataset.active++;
      }else{
        sliderContainer.dataset.slide--;
        sliderContainer.dataset.active--;
      }

      const animationSlider = function () {
        sliderContainer.style.marginLeft = (-178 * sliderContainer.dataset.slide + 'px')
      }

      window.addEventListener('resize', animationSlider);
      animationSlider();
      buttonAnimation();
    }

    window.addEventListener('resize', responsiveSlider);
    responsiveSlider();
    buttonAnimation();

    document.querySelector('#team-slide-next').addEventListener('click', () => slideAnimation('next', sliderContainer.children.length));
    document.querySelector('#team-slide-prev').addEventListener('click', () => slideAnimation('prev', sliderContainer.dataset.default));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["works-with-alexa"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const responsiveBanner = function(){
      const banner = document.querySelector('.alexa-banner-container')
      window.matchMedia('(max-width: 479px)').matches ? banner.style.backgroundImage = 'url(' + banner.dataset.mobile + ')' :  banner.style.backgroundImage = 'url(' + banner.dataset.desktop + ')';
    }

    responsiveBanner();

    window.addEventListener('resize', () => responsiveBanner());
  })();

  } catch(e) { console.error(e); }
})();
})();
